import firestore, { firebase } from '@/firebase'
import textHelper from '@/helpers/textHelper'
export default {
  state: {
    otherActivities: []
  },
  getters: {
    otherActivities: state => state.otherActivities
  },
  mutations: {
    setOtherActivities(state, otherActivities) {
      state.otherActivities = otherActivities
    },
    addOtherActivity(state, otherActivity) {
      state.otherActivities.push(otherActivity)
      return otherActivity
    },
    updateOtherActivity(state, otherActivity) {
      const idx = state.otherActivities.findIndex(
        c => c.id === otherActivity.id
      )
      state.otherActivities[idx] = otherActivity
      state.otherActivities = [...state.otherActivities]
    },
    deleteOtherActivities(state, otherActivities) {
      for (const { id } of otherActivities) {
        const idx = state.otherActivities.findIndex(c => c.id === id)
        state.otherActivities.splice(idx, 1)
      }
    }
  },
  actions: {
    addOtherActivity({ commit, rootState }, otherActivity) {
      const userId = rootState.user.user.id
      otherActivity.userId = userId
      otherActivity.createdAt = firebase.firestore.FieldValue.serverTimestamp()
      otherActivity.updatedAt = firebase.firestore.FieldValue.serverTimestamp()
      return firestore
        .collection('OtherActivities')
        .add(otherActivity)
        .then(doc => doc.get())
        .then(otherActivity => {
          return commit('addOtherActivity', {
            id: otherActivity.id,
            ...otherActivity.data()
          })
        })
    },
    updateOtherActivity({ commit, rootState }, otherActivity) {
      otherActivity.updatedAt = firebase.firestore.FieldValue.serverTimestamp()
      return firestore
        .collection('OtherActivities')
        .doc(otherActivity.id)
        .update(otherActivity)
        .then(() => {
          return commit('updateOtherActivity', otherActivity)
        })
    },
    setOtherActivities({ commit, rootState }, otherActivities) {
      commit('setOtherActivities', otherActivities)
    },
    getOtherActivities({ commit, rootState }) {
      const userId = rootState.user.user.id
      return firestore
        .collection('OtherActivities')
        .where('userId', '==', userId)
        .get()
        .then(snapshot => {
          const otherActivities = snapshot.docs.map(doc => ({
            ...doc.data(),
            id: doc.id
          }))
          commit('setOtherActivities', otherActivities)
        })
    },
    deleteOtherActivities({ commit }, otherActivities) {
      const batch = firestore.batch()
      for (const { id } of otherActivities) {
        const docRef = firestore.collection('OtherActivities').doc(id)
        batch.delete(docRef)
      }
      return batch.commit().then(() => {
        commit('deleteOtherActivities', otherActivities)
      })
    }
  }
}
